<table class="w-full">
  <thead>
    <tr class="border-b border-slate-600 text-muted text-sm">
      <td></td>
      <td></td>
      <td class="text-right px-1 py-3">Score</td>
      <td class="text-right px-1 py-3">Participation</td>
      <td class="text-right px-1 py-3">Knowledge</td>
      <td></td>
    </tr>
  </thead>

  <tbody *ngIf="explanations">

    <tr *ngFor="let e of explanations" class="odd:bg-slate-800">

      <td class="text-left text-sm px-1 py-2" [class]="(e.bonus) ? 'text-yellow-200': ''">
        <fa-icon icon="star" *ngIf="e.bonus" class="mr-1"></fa-icon>
        <span *ngIf="e.type == 'QUIZ'">
          Question {{e.questionIndex + 1}}
        </span>
        <span *ngIf="e.type == 'CLASS_TASK'">
          {{e.subtaskName}}
        </span>
        <span *ngIf="e.type == 'VOLUNTEER_TASK'">
          Volunteer task
        </span>
      </td>

      <td class="text-center px-1">
        <span *ngIf="e.type == 'QUIZ'">
          <span *ngIf="!e.answered" class="text-muted" matTooltip="Question not answered">
            <fa-icon icon="circle-minus"></fa-icon>
          </span>
          <span *ngIf="e.answered && !e.correct" class="text-negative text-sm" matTooltip="Question answered incorrectly">
            <fa-icon icon="times-circle"></fa-icon>
          </span>
          <span *ngIf="e.answered && e.correct" class="text-positive text-sm" matTooltip="Question answered correctly">
            <fa-icon icon="circle-check"></fa-icon>
          </span>
        </span>

        <span *ngIf="e.type == 'CLASS_TASK'">
          <span *ngIf="!e.completed" class="text-negative" matTooltip="Task not completed">
            <fa-icon icon="circle-minus"></fa-icon>
          </span>
          <span *ngIf="e.completed && !e.assessment" matTooltip="Task completed but not assessed">
            <fa-icon icon="circle-check"></fa-icon>
          </span>
          <span *ngIf="e.completed && e.assessment == 'GOOD'" class="text-positive" matTooltip="Task completed to a good standard">
            <fa-icon icon="face-grin-stars"></fa-icon>
          </span>
          <span *ngIf="e.completed && e.assessment == 'OK'" class="text-amber" matTooltip="Task completed to an ok standard">
            <fa-icon icon="face-smile"></fa-icon>
          </span>
          <span *ngIf="e.completed && e.assessment == 'POOR'" class="text-negative" matTooltip="Task completed to a poor standard">
            <fa-icon icon="face-meh"></fa-icon>
          </span>
        </span>

        <span *ngIf="e.type == 'VOLUNTEER_TASK'">
          <span *ngIf="!e.optedIn" class="text-negative" matTooltip="Opted out">
            <fa-icon icon="thumbs-down"></fa-icon>
          </span>
          <span *ngIf="e.optedIn && !e.assessment" class="text-positive" matTooltip="Opted in but not selected">
            <fa-icon icon="thumbs-up"></fa-icon>
          </span>
          <span *ngIf="e.optedIn && e.assessment == 'GOOD'" class="text-positive" matTooltip="Opted in and got good feedback">
            <fa-icon icon="face-grin-stars"></fa-icon>
          </span>
          <span *ngIf="e.optedIn && e.assessment == 'OK'" class="text-amber" matTooltip="Opted in and got ok feedback">
            <fa-icon icon="face-smile"></fa-icon>
          </span>
          <span *ngIf="e.optedIn && e.assessment == 'POOR'" class="text-negative" matTooltip="Opted in and got poor feedback">
            <fa-icon icon="face-meh"></fa-icon>
          </span>
        </span>

      </td>

      <td class="text-right px-1">
        <span [class]="getScoreClass(e.pointsEarned)">{{getFormattedScore(e.pointsEarned)}}</span>
      </td>

      <td class="text-right px-1">
        <span *ngIf="e.bonus" [class]="(e.participationPointsEarned > 0) ? 'text-yellow-200': 'text-muted text-sm'">
          {{e.participationPointsEarned}}
        </span>
        <span *ngIf="!e.bonus" [class]="getRatioClass(e.participationPointsEarned, e.participationPointsOffered)">
          {{e.participationPointsEarned}}/{{e.participationPointsOffered}}
        </span>

      </td>

      <td class="text-right px-1">
        <span *ngIf="e.bonus" [class]="(e.knowledgePointsEarned > 0) ? 'text-yellow-200': 'text-muted text-sm'">
          {{e.knowledgePointsEarned}}
        </span>
        <span *ngIf="!e.bonus" [class]="getRatioClass(e.knowledgePointsEarned, e.knowledgePointsOffered)">
          {{e.knowledgePointsEarned}}/{{e.knowledgePointsOffered}}
        </span>
      </td>

      <td class="text-center">
        <a *ngIf="canAdjust" [class]="(e.adjustmentExplanation) ? '': 'text-muted'" (click)="makeAdjustment(e)" [matTooltip]="e.adjustmentExplanation">
          <fa-icon icon="note-sticky"></fa-icon>
        </a>

        <span *ngIf="!canAdjust && e.adjustmentExplanation" [matTooltip]="e.adjustmentExplanation">
          <fa-icon icon="note-sticky"></fa-icon>
        </span>
      </td>
    </tr>

    <tr class="border-t border-slate-600 text-right text-sm text-muted">
      <td >

      </td>

      <td></td>

      <td class="text-right px-1">
      </td>

      <td class="text-right px-1">
        <span *ngIf="participationPointsEarned > participationPointsOffered">
          {{participationPointsOffered}}/{{participationPointsOffered}} + {{participationPointsEarned - participationPointsOffered}}
        </span>
        <span *ngIf="participationPointsEarned <= participationPointsOffered">
          {{participationPointsEarned}}/{{participationPointsOffered}}
        </span>
      </td>

      <td class="text-right px-1">
        <span *ngIf="knowledgePointsEarned > knowledgePointsOffered">
          {{knowledgePointsOffered}}/{{knowledgePointsOffered}} + {{knowledgePointsEarned - knowledgePointsOffered}}
        </span>
        <span *ngIf="knowledgePointsEarned <= knowledgePointsOffered">
          {{knowledgePointsEarned}}/{{knowledgePointsOffered}}
        </span>
      </td>
    </tr>

    <tr>
      <td >

      </td>

      <td></td>

      <td class="text-right px-1">
        <h4>{{pointsEarned}}</h4>
      </td>

      <td class="text-right px-1">
        <app-hud [pointsEarned]="participationPointsEarned" [pointsOffered]="participationPointsOffered"></app-hud>
      </td>

      <td class="text-right px-1">
        <app-hud [pointsEarned]="knowledgePointsEarned" [pointsOffered]="knowledgePointsOffered"></app-hud>
      </td>


    </tr>
  </tbody>

</table>
